import React, { useState, useEffect } from "react";
import axiosapi from "../api/axiosapi";
import { Link } from "react-router-dom";
import SideMenu from "../components/SideMenu";
import Footer from "../components/Footer";
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
import { Helmet } from 'react-helmet';
import useAuth from '../hooks/useAuth';

const splitContent = (sentence) => {
    const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
    const matches = sentence.matchAll(InlineMathRegex);
    let lastIndex = 0;
    const contentArray = [];
  
    for (const match of matches) {
        const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
        const restOfContent = sentence.substring(lastIndex, match.index);
    
        contentArray.push(restOfContent, InlineMathContent);
        lastIndex = match.index + match[0].length;
    }
  
    if (lastIndex < sentence.length) {
        contentArray.push(sentence.substring(lastIndex));
    }
  
    return <div>{contentArray}</div>;
};

const makeURL = (numChar, divChar) => {
    let ranNum1 = Math.floor(Math.random() * 4) + 1;
    let ranNum2 = Math.floor(Math.random() * 4) + 6;
    let ranNum3 = Math.floor(Math.random() * 4) + 1;
    let ranNum4 = Math.floor(Math.random() * 3) + 7;
    let char0 = String(ranNum1);
    let char1 = (ranNum1 === 1 ? numChar[0] : `${Math.floor(Math.random() * 10)}`);
    let char2 = (ranNum1 === 2 ? numChar[0] : `${Math.floor(Math.random() * 10)}`);
    let char3 = (ranNum1 === 3 ? numChar[0] : `${Math.floor(Math.random() * 10)}`);
    let char4 = (ranNum1 === 4 ? numChar[0] : `${Math.floor(Math.random() * 10)}`);
    let char5 = String(ranNum2);
    let char6 = (ranNum2 === 6 ? numChar[1] : `${Math.floor(Math.random() * 10)}`);
    let char7 = (ranNum2 === 7 ? numChar[1] : `${Math.floor(Math.random() * 10)}`);
    let char8 = (ranNum2 === 8 ? numChar[1] : `${Math.floor(Math.random() * 10)}`);
    let char9 = (ranNum2 === 9 ? numChar[1] : `${Math.floor(Math.random() * 10)}`);
    let char10 = String(ranNum3);
    let char11 = (ranNum3 === 1 ? numChar[2] : `${Math.floor(Math.random() * 10)}`);
    let char12 = (ranNum3 === 2 ? numChar[2] : `${Math.floor(Math.random() * 10)}`);
    let char13 = (ranNum3 === 3 ? numChar[2] : `${Math.floor(Math.random() * 10)}`);
    let char14 = (ranNum3 === 4 ? numChar[2] : `${Math.floor(Math.random() * 10)}`);
    let char15 = divChar;
    let char16 = String(ranNum4);
    let char17 = (ranNum4 === 7 ? numChar[3] : `${Math.floor(Math.random() * 10)}`);
    let char18 = (ranNum4 === 8 ? numChar[3] : `${Math.floor(Math.random() * 10)}`);
    let char19 = (ranNum4 === 9 ? numChar[3] : `${Math.floor(Math.random() * 10)}`);
    const char = char0+char1+char2+char3+char4+char5+char6+char7+char8+char9+char10+char11+char12+char13+char14+char15+char16+char17+char18+char19;

    return char
};

const HomeForProblem = () => {
    const [todayProblemList, setTodayProblemList] = useState([]);
    const [improveMathAbilityBeginner, setImproveMathAbilityBeginner] = useState([]);
    const [improveMathAbilityEasy, setImproveMathAbilityEasy] = useState([]);
    const [improveMathAbilityMedium, setImproveMathAbilityMedium] = useState([]);
    const [improveMathAbilityHard, setImproveMathAbilityHard] = useState([]);
    const [improveMathAbilityVeryHard, setImproveMathAbilityVeryHard] = useState([]);
    const [errPT, setErrPT] = useState();
    const [err2, setErr2] = useState();
    const {setAuth} = useAuth();
    const [loading, setLoading] = useState(true);

    const styles = {
        header: {
            background: 'linear-gradient(135deg, #1e3a8a, #2563eb)',
            color: '#fff',
            padding: '80px 20px 100px',
            textAlign: 'center'
        },
        ht1: {
            fontSize: '2.8rem',
            margin: '20px 0 10px',
            fontWeight: 800
        },
        headerP: {
            fontSize: '1.2rem',
            opacity: 0.95,
            maxWidth: '760px',
            margin: '0 auto 30px'
        },
        cta: {
            display: 'inline-block',
            background: '#fff',
            color: '#2563eb',
            padding: '14px 28px',
            borderRadius: '999px',
            fontWeight: 700,
            textDecoration: 'none',
            boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
            cursor: 'pointer'
        },
        section: {
            padding: '80px 20px',
            maxWidth: '1600px',
            margin: '0 auto'
        },
        ht2: {
            fontSize: '2.2rem',
            marginBottom: '20px',
            textAlign: 'center'
        },
        lead: {
            maxWidth: '800px',
            margin: '0 auto 60px',
            textAlign: 'center',
            fontSize: '1.1rem',
            color: '#555'
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: '30px'
        },
        card: {
            background: '#fff',
            borderRadius: '20px',
            padding: '30px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.08)'
        },
        cardH3: {
            marginTop: 0,
            fontSize: '1.3rem',
            color: '#1e40af'
        },
        levels: {
            background: '#eef2ff',
            borderRadius: '30px',
            padding: '60px 40px'
        },
        level: {
            background: '#fff',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
        },
        levelSpan: {
            display: 'block',
            fontWeight: 800,
            color: '#2563eb',
            marginBottom: '8px'
        },
        footer: {
            background: '#0f172a',
            color: '#cbd5f5',
            padding: '40px 20px',
            textAlign: 'center',
            fontSize: '0.9rem'
        },
        footerA: {
            color: '#93c5fd',
            textDecoration: 'none'
        }
    };

    useEffect(() => {
        const controller = new AbortController();

        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    // console.log(JSON.stringify(prev));
                    // console.log(response.data.access_token);
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    // console.log(JSON.stringify(prev));
                    // console.log(response.data.access_token);
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        fetchToken();

        // const fetchTodayProblem = async () => {
        //     try {
        //         const response = await axiosapi.get('/home/hometodayproblem/')
        //         response.data && setTodayProblemList(response.data.todayProblemList);
        //         // response.data && response.data.imageList.length > 0 && setImageList(response.data.imageList);
        //         // response.data && setImageProblem(response.data.imageProblem);
        //     } catch (err) {
        //         setErrPT(err.message);
        //         if (err.response) {
        //             console.log(err.response.data);
        //             console.log(err.response.status);
        //             console.log(err.response.headers);
        //         } else {
        //             console.log(`Error: ${err.message}`);
        //         }
        //     }
        // }
        // fetchTodayProblem();

        const fetchImproveAbility = async () => {
            try {
                const response2 = await axiosapi.get('/home/homeimproveability/')
                response2.data && setImproveMathAbilityBeginner(response2.data.beginner); 
                response2.data && setImproveMathAbilityEasy(response2.data.easy); 
                response2.data && setImproveMathAbilityMedium(response2.data.medium);
                response2.data && setImproveMathAbilityHard(response2.data.hard);
                response2.data && setImproveMathAbilityVeryHard(response2.data.veryHard);
            } catch (err2) {
                setErr2(err2);
            }
        }
        fetchImproveAbility();

        return () => controller.abort();
    },[])

    // 텍스트를 50 자로 제한하는 함수
    const truncateText = (text, limit) => {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
    };

    return(
        <div>
            
            <Helmet>
                <meta property="og:title" content="티프매쓰" />
                <meta property="og:description" content="안녕하세요. 티프매쓰입니다." />
                {/* <meta property="og:image" content="https://example.com/thumbnail.jpg" />
                <meta property="og:url" content="https://example.com" />
                <meta property="og:type" content="website" /> */}
            </Helmet>

            <section style={{...styles.section, ...styles.levels}}>
                <h2 style={styles.ht2}>두뇌를 자극하는 작도 문제</h2>
                <p style={styles.lead}>
                    작도 문제들을 해결하며 지적인 짜릿함을 느껴보세요.<br />
					주기적으로 약 6,000개의 작도 문제에서 선정된 새로운 문제들이 추가됩니다.
                </p>
                <div style={styles.grid}>
                    <Link 
                        to="/improvemathability"
                        state={{
                            "improveAbilityType": "beginner"
                        }}
                    >
                        <div style={styles.level}>
                            <span style={styles.levelSpan}>Phase 1 · 입문</span>
                            <p style={{color: "black", fontWeight: "normal"}}>점과 선으로 기하 감각 깨우기</p>
                        </div>
                    </Link>
                    <Link 
                        to="/improvemathability"
                        state={{
                            "improveAbilityType": "easy"
                        }}
                    >
                        <div style={styles.level}>
                            <span style={styles.levelSpan}>Phase 2 · 기초</span>
                            <p style={{color: "black", fontWeight: "normal"}}>관계를 읽는 힘의 확인</p>
                        </div>
                    </Link>
                    <Link 
                        to="/improvemathability"
                        state={{
                            "improveAbilityType": "medium"
                        }}
                    >
                        <div style={styles.level}>
                            <span style={styles.levelSpan}>Phase 3 · 도약</span>
                            <p style={{color: "black", fontWeight: "normal"}}>도형 성질을 연결하는 사고</p>
                        </div>
                    </Link>
                    <Link 
                        to="/improvemathability"
                        state={{
                            "improveAbilityType": "hard"
                        }}
                    >
                        <div style={styles.level}>
                            <span style={styles.levelSpan}>Phase 4 · 심화</span>
                            <p style={{color: "black", fontWeight: "normal"}}>구조 전체를 보는 논리</p>
                        </div>
                    </Link>
                    <Link 
                        to="/improvemathability"
                        state={{
                            "improveAbilityType": "veryHard"
                        }}
                    >
                        <div style={styles.level}>
                            <span style={styles.levelSpan}>Phase 5 · 초월</span>
                            <p style={{color: "black", fontWeight: "normal"}}>기하의 신비를 발견하는 도전</p>
                        </div>
                    </Link>
                </div>
            </section>

            <section style={styles.section}>
                <h2 style={styles.ht2}>작도 중심의 체계적인 사고력 훈련하기</h2>
                <p style={styles.lead}>
                    도형의 작도 및 변형으로 생각하는 힘을 강화하는 다양한 학습 활동이 체계적으로 이루어집니다.
                </p>
                <div style={styles.grid}>
                    <Link className="nav-link" to={`/grade/brainup/list/`}>
                        <div style={styles.card}>
                            <h3 style={styles.cardH3}>그리며 생각 키우기</h3>
                            <p style={{color: "black", fontWeight: "normal"}}>기하 주제별로 사고의 폭과 깊이를 체계적으로 확장하도록 설계된 단계별 커리큘럼을 제공합니다.</p>
                        </div>
                    </Link>
                    <Link className="nav-link" to={`/grade/textbook/list/`}>
                        <div style={styles.card}>
                            <h3 style={styles.cardH3}>그리며 학교 공부하기</h3>
                            <p style={{color: "black", fontWeight: "normal"}}>초등학교 교과서 속 개념과 원리를 도형으로 그리고 표현하며 이해의 폭과 깊이를 높입니다.</p>
                        </div>
                    </Link>
                    <Link className="nav-link" to={`/geometriccoloring`}>
                        <div style={styles.card}>
                            <h3 style={styles.cardH3}>색칠하기</h3>
                            <p style={{color: "black", fontWeight: "normal"}}>도형에 색을 입혀 예쁘게 꾸미면서 도형을 전체와 부분으로 보는 감각을 길러줍니다.</p>
                        </div>
                    </Link>
                    <Link className="nav-link" to={`/calculationexercise/list`}>
                        <div style={styles.card}>
                            <h3 style={styles.cardH3}>연산연습</h3>
                            <p style={{color: "black", fontWeight: "normal"}}>양적 변화의 의미를 담아내는 연산으로, 기계적 계산만 아니라 사고력을 기르는 생각하는 연산법을 습득합니다.</p>
                        </div>
                    </Link>
                </div>
            </section>

            <div className="App-full-container">
                <div style={{width:"100%"}}>
                    <Footer/>
                </div>
                
            </div>
        </div>
    );
}

export default HomeForProblem;
